import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  FlexRow: styled('div')<{ $isMobile?: boolean }>(({ $isMobile }) => ({
    display: 'flex',
    flexDirection: $isMobile ? 'column' : 'row',
    gap: $isMobile ? '15px' : '20px',
    marginBottom: '20px'
  })),

  SectionFilters: styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    margin: '0 auto',
    marginBottom: '25px'
  }),

  RectangleBar: styled('div')({
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px',
    width: '100%'
  }),

  ContentContainer: styled('div')({
    display: 'flex',
    flex: 1
  }),

  FlexContainer: styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px'
  }),

  ShowText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529'
  }),

  SelectContainer: styled('div')({
    select: {
      padding: '5px',
      fontSize: '16px',
      border: '0.5px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      }
    }
  }),

  CheckboxContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px'
    }
  })),

  CheckboxRow: styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px'
    }
  })),

  CheckboxLabel: styled('label')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '15px',
    color: '#495057',
    cursor: 'pointer',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#212529'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  RecordsText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529'
  }),

  MainContent: styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '1200px',
    margin: '0 auto',
    backgroundColor: '#ffffff'
  }),

  PageContent: styled('div')({
    maxWidth: '1000px',
    padding: '10px',
    width: '100%'
  }),

  PropertyListContainer: styled('div')({
    padding: '90px',
    paddingTop: '60px',
    margin: '0 10px',
    backgroundColor: '#EBEBEB',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px'
  }),

  PropertyCard: styled('div')({
    height: '160px',
    width: '860px',
    backgroundColor: 'white',
    display: 'flex',
    marginLeft: '-40px',
    flexDirection: 'row',
    borderRadius: '5px',
    overflow: 'hidden'
  }),

  CardContent: styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '16px'
  }),

  CardTitle: styled('div')({
    fontSize: '24px',
    fontWeight: 600,
    color: '#000000'
  }),

  CardButtons: styled('div')({
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '16px'
  }),

  ViewButton: styled(Button)({
    width: '130.12px',
    height: '47.6px',
    backgroundColor: '#2C62C7',
    borderRadius: '10px',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#1E4A8E'
    }
  }),

  EditButton: styled(Button)({
    width: '130.12px',
    height: '47.6px',
    backgroundColor: '#FF0000',
    borderRadius: '10px',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#FF0011'
    }
  }),

  SearchContainer: styled('div')({
    marginRight: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '5px'
  }),

  SearchInput: styled('input')({
    width: '250px',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #5D5F64',
    borderRadius: '5px',
    backgroundColor: '#F8F8F8',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),

  Pagination: styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '15px',
    marginRight: '10px',
    paddingBottom: '25px',

    button: {
      padding: '8px 16px',
      cursor: 'pointer',
      color: 'white',
      border: '1px solid #ddd',
      backgroundColor: '#2C62C7',
      borderRadius: '5px',
      '&.active': {
        backgroundColor: '#0B327A',
        color: 'white'
      },

      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: '#2C62C7',
        color: 'white'
      }
    }
  }),

  FormFieldContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    marginBottom: '15px'
  }),

  FormLabel: styled('label')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#212529'
  }),

  FormInput: styled('input')<{ $isMobile?: boolean; $fullWidth?: boolean }>(
    ({ $isMobile, $fullWidth }) => ({
      padding: '10px',
      fontSize: '16px',
      border: '1px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      width: $fullWidth ? '100%' : $isMobile ? '100%' : 'auto',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      }
    })
  )
};
